import React from 'react';
import { NewCoreIconProps } from '@atlaskit/icon/dist/types/types';

const AiAgentIcon: React.FC<NewCoreIconProps> = ({ label, ...props }) => {
  return (
    <svg width="16" height="16" fill="none" viewBox="0 0 16 16" aria-label={label} {...props}>
      <defs>
        <mask id="star-cutout">
          <rect width="16" height="16" fill="white" />
          <path
            fill="black"
            fillRule="evenodd"
            d="M7.5 4a.75.75 0 0 1 1.41 0l.615 1.687 1.686.615a.75.75 0 0 1 0 1.41l-1.686.615-.615 1.686a.75.75 0 0 1-1.41 0l-.615-1.686-1.687-.615a.75.75 0 0 1 0-1.41l1.687-.615z"
            clipRule="evenodd"
          />
        </mask>
      </defs>
      {/* Rounded square with star cutout */}
      <rect
        x="1"
        y="1"
        width="14"
        height="12"
        rx="2"
        ry="2"
        fill="currentcolor"
        mask="url(#star-cutout)"
      />
      {/* Centered triangular tail - overlapping to eliminate line */}
      <path fill="currentcolor" d="M4 12L8 17L12 12L4 12z" />
    </svg>
  );
};

export default AiAgentIcon;
